import { type RefObject, useCallback, useEffect, useState } from "react"

interface UseReportFullscreen {
  isFullscreen: boolean
  toggle: () => void
}

// Wraps the browser Fullscreen API for a single container element, keeping local
// state in sync with browser-driven exits (Esc, OS chrome).
export function useReportFullscreen(
  ref: RefObject<HTMLElement | null>
): UseReportFullscreen {
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    const onChange = () =>
      setIsFullscreen(document.fullscreenElement === ref.current)
    document.addEventListener("fullscreenchange", onChange)
    return () => document.removeEventListener("fullscreenchange", onChange)
  }, [ref])

  const toggle = useCallback(() => {
    const element = ref.current
    if (!element) return
    if (document.fullscreenElement) {
      void document.exitFullscreen?.()
    } else {
      void element.requestFullscreen?.()
    }
  }, [ref])

  return { isFullscreen, toggle }
}
